import { defineMessages } from 'react-intl'

export default defineMessages({
  noOptions: {
    id: 'containers.EmbeddedDealPage.components.Services.noOptions',
    defaultMessage: 'No services called',
  },
  searching: {
    id: 'containers.EmbeddedDealPage.components.Services.searching',
    defaultMessage: 'Searching for',
  },
  services: {
    id: 'containers.EmbeddedDealPage.components.Services.services',
    defaultMessage: 'Services',
  },
})
